import Hero from "../components/Hero";
import InfoSection from "../components/InfoSection";
import BandsSection from "../components/BandsSection";
import SponsorsSection from "../components/SponsorsSection";
import ContactSection from "../components/ContactSection";

export default function Home() {
  return (
    <>
      <Hero />
      <InfoSection />
      <BandsSection />
      <SponsorsSection />
      <ContactSection />
    </>
  );
}
